import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import './index.css'

const Container = styled.div`
  max-width: 42rem;
  margin: auto;
  padding: 0 1.0875rem;
`

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Patrik Wibron - Front End Developer"
      meta={[
        { name: 'description', content: 'Front End Developer in Stockholm' },
      ]}
    />
    <Container>
      {children()}
    </Container>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js